import { createApp } from 'vue'
import options from './ContributionSelector.options'

const el = '.kb-component--contribution-selector'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((ContributionSelectorDOM) => {
            const template = ContributionSelectorDOM.outerHTML
            const data = JSON.parse(ContributionSelectorDOM.dataset.data)
            options.template = template
            const component = createApp(options, { data }).use(Store)
            component.mount(ContributionSelectorDOM)
        })
    }
}
